import type { GeocodeAutocompleteResponse } from "@/types/geo-code";
import { axiosInstance } from "./client";

export const fetchSuggestedLocations = async (query: string | undefined) => {
  if (!query) return;
  const response = await axiosInstance.get<GeocodeAutocompleteResponse>(
    `/suggestion/address-list?text=${query}`,
  );
  return response.data;
};
